import NodeRSA from 'node-rsa';

/**
 * @desc: RSA加密
 * @param publicKey: string
 * @param data: string
 * @return 加密字符串
 */
export function encryptPkca1(publicKey, data) {
  const key = new NodeRSA(publicKey, 'public', { encryptionScheme: 'pkcs1' });
  const encrypt1 = key.encrypt(data, 'base64');
  return encrypt1.replace(/\//g, '_').replace(/\+/g, '-');
}
